import { render, staticRenderFns } from "./VerProduccion.vue?vue&type=template&id=70c445d3&scoped=true"
import script from "./VerProduccion.vue?vue&type=script&lang=js"
export * from "./VerProduccion.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerProduccion.vue?vue&type=style&index=1&id=70c445d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c445d3",
  null
  
)

export default component.exports